module.exports = __webpack_public_path__ + "e49d52e74b7689a0727def99da31f3eb.ttf";


//////////////////
// WEBPACK FOOTER
// ./bower_components/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = 444
// module chunks = 0